import React from "react";

const Icon = () => (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="20" cy="20" r="20" fill="#637282"/>
        <path d="M20 10C18.8972 10 18 10.8976 18 12.0009C18 13.1032 18.8972 14 20 14C21.1028 14 22 13.1032 22 12.0009C22 10.8976 21.1028 10 20 10Z" fill="white"/>
        <path d="M20 18C18.8955 18 18 18.6716 18 19.5V28.5C18 29.3284 18.8955 30 20 30C21.1045 30 22 29.3284 22 28.5V19.5C22 18.6716 21.1045 18 20 18Z" fill="white"/>
    </svg>
)

export default Icon;